
export const getIfFtrQuestionOptional = (...args) => {
    const [ isRealtimeCheckEnabled, personInfo ] = args;

    // If real time check is not enabled, then the FTR question is not optional
    if (!isRealtimeCheckEnabled) {
        return false;
    }

    // FTR question is optional if SSN is provided and spouse SSN is provided (if there is a spouse)
    return !!(
        personInfo.isSsnProvided &&
        (personInfo.spouseIndex === null ? true : personInfo.isSpouseProvidedSsn)
    );
};